import CircularProgress from '@mui/material/CircularProgress'
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api'
import { useCallback, useEffect, useState } from 'react'

import AppConfig from '../../config/AppConfig'

const containerStyle = {
  width: '100%',
  height: '100%',
}

//Default to Boston
const defaultBounds = {
  lat: 42.3601,
  lng: -71.0589,
}

interface GoogleMapProps {
  locations: { latitude: string; longitude: string }[]
  style?: React.CSSProperties
}

const GoogleMapContainer: React.FC<React.PropsWithChildren<GoogleMapProps>> = ({
  locations,
  style = {},
}) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: AppConfig.GOOGLE_MAPS_API_KEY || '',
  })
  const [map, setMap] = useState<null | google.maps.Map>(null)

  useEffect(() => {
    if (map) {
      const boundInstance = new window.google.maps.LatLngBounds()
      let bounds
      if (locations.length) {
        bounds = locations.map(
          (location) =>
            new window.google.maps.LatLng(
              parseFloat(location.latitude),
              parseFloat(location.longitude),
            ),
        )
      } else {
        bounds = [
          new window.google.maps.LatLng(defaultBounds.lat, defaultBounds.lng),
        ]
      }

      bounds.forEach((latLng) => {
        boundInstance.extend(latLng)
      })

      map.fitBounds(boundInstance)
    }
  }, [map, locations])

  const onLoad = useCallback((map: google.maps.Map) => {
    map.setOptions({ maxZoom: 15 })
    setMap(map)
  }, [])

  const onUnmount = useCallback(function callback() {
    setMap(null)
  }, [])

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={{ ...containerStyle, ...style }}
      center={defaultBounds}
      onLoad={onLoad}
      onUnmount={onUnmount}
    >
      {locations.map((location, i) => (
        <Marker
          key={i} // eslint-disable-line react/no-array-index-key
          position={{
            lat: parseFloat(location.latitude),
            lng: parseFloat(location.longitude),
          }}
        />
      ))}
    </GoogleMap>
  ) : (
    <div style={{ ...containerStyle, ...style }}>
      <CircularProgress />
    </div>
  )
}
export default GoogleMapContainer
